import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import { Drawer } from "@mui/material";
import Header from "../Header/Header";
import RightMenu from "../RightMenu";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const Success = (props) => {
    const [state, setState] = React.useState({ right: false });
    const [data, setData] = useState(undefined);
    const [cookies, setCookie, removeCookie] = useCookies();


    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };
    useEffect(() => {
        getData();
    }, [])
    function getData(number = 1) {

        const url = Constants.apiUrl + "/api/cronjob/success/get?page=" + number;
        axios.get(url, {
            headers: {
                Authorization: "Bearer " + cookies.user_server_token,
            },
        })
            .then((r) => {
                setData(r.data.data);
            })
            .catch((e) => {

            });
    }
    const timeToDate = (unixTimestamp) => {
        const date = new Date(unixTimestamp);
        return date.toDateString();
    }

    return (
        <React.Fragment>
            <Breadcrumb title={"   کرونجاب های موفق  "} />

            <div className="container">

                <div className="row">
                    <div className="text-center w-100 my-4">

                    </div>
                    <div className="mt-2  table-responsive">
                        <table className="table table-hover  ">
                            <tr className="bg-success text-white">

                                <td>
                                    شناسه
                                </td>
                                <td>
                                    نام کرون جاب
                                </td>

                                <td>
                                    تاریخ
                                </td>

                            </tr>
                            {
                                data != undefined && Object.values(data.data).map((item, index) => {
                                    return (<tr>
                                        <td>
                                            {item.id}
                                        </td>
                                        <td>
                                            {item.cron_job_name}
                                        </td>

                                        <td>
                                            {timeToDate(item.created_at)}
                                        </td>
                                    </tr>
                                    );
                                })
                            }
                        </table>

                    </div>
                    <div className='pager Page navigation example'>
                        {data != undefined && <Pagination
                            totalItemsCount={data.total}
                            activePage={data.current_page}
                            itemsCountPerPage={data.per_page}
                            onChange={(number) => {
                                getData(number);
                            }}
                            itemClass="page-item"
                            linkClass='page-link'
                            firstPageText="اولین صفحه"
                            lastPageText="آخرین صفحه"
                            nextPageText="بعدی"
                            prevPageText="قبلی"
                            activeClass='pageactive'

                        />}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default Success;
